{
    "general": {
        "buttons": {
            "newAddress": "Nieuw adres",
            "back": "Terug",
            "useAddress": "Gebruiken",
            "closeModal": "Sluiten",
            "confirmSelection": "Bevestig selectie",
            "addressesSelected": {
                "singular": "adres geselecteerd",
                "plural": "adressen geselecteerd"
            },
            "cancel": "Annuleren",
            "next": "Volgende",
            "addArea": "Gebied toevoegen"
        },
        "labels": {
            "zipcode": "Postcode",
            "zipcodePlaceholder": "0000XX",
            "houseNumber": "Huisnummer",
            "streetName": "Straatnaam",
            "streetNamePlaceholder": "Voorbeeldstraat",
            "addressFound": {
                "singular": "Adres gevonden",
                "plural": "Adressen gevonden"
            },
            "houseNumberPlaceholder": "XX",
            "radiusLabel": "Straal (m)",
            "houseValueLabel": "Woningwaarde (x € 1000)",
            "filterOn": "Filter op",
            "filterRentalOption": "Huur",
            "filterSaleOption": "Koop",
            "addresses": {
                "singular": "adres",
                "plural": "adressen"
            },
            "total": "Totaal",
            "areas": "Gebieden",
            "selected": "Geselecteerd",
            "houseType": "Type huis",
            "allTypes": "Alle types",
            "clearSearch": "Zoekopdracht wissen",
            "clearSelected": "Geselecteerde wissen",
            "noOptions": "Geen opties",
            "search": "Zoeken",
            "selectAll": "Alles selecteren",
            "selectAllFiltered": "Alles selecteren",
            "selectSomeItems": "Alle types",
            "create": "Aanmaken"
        },
        "houseTypes": {
            "Appartement": "Appartement",
            "Vrijstaande woning": "Vrijstaande woning",
            "Tussenwoning": "Tussenwoning",
            "Hoekwoning": "Hoekwoning",
            "2-onder-1-kapwoning": "2-onder-1-kapwoning"
        },
        "messages": {
            "addressNotFound": {
                "singular": "Geen adres gevonden",
                "plural": "Geen adressen gevonden"
            },
            "addressNotFoundForSelected": "Geen adres gevonden voor:",
            "addressesNotFoundForSelection": "Geen adressen gevonden voor selectie",
            "generalError": "Oeps! Er is iets misgegaan.",
            "addressLimitExceeded": {
                "singular": "Je kunt maximaal {{max}} adressen selecteren. {{count}} adres zal niet worden geselecteerd.",
                "plural": "Je kunt maximaal {{max}} adressen selecteren. {{count}} addressen zullen niet worden geselecteerd."
            },
            "addressMinimum": "Selecteer minimaal {{min}} adressen om door te gaan.",
            "zipCodeAreaLimitError": "Er moeten minimaal {{limit}} adressen worden geselecteerd per postcodegebied / regio. Pas je zoekgebied aan door de straal te vergroten of voeg een tweede gebied toe.",
            "zipCodeAreaSelectionLimitError": "Er moeten minimaal {{limit}} adressen worden geselecteerd per postcodegebied / regio."
        }
    },
    "slideInPanel": {
        "header": {
            "title": "Adressen"
        },
        "tableColumnLabels": {
            "streetName": "Straat",
            "amountName": "Aantal",
            "zipCodeArea": "Postcodegebied"
        },
        "content": {
            "noSelection": "Selecteer een aantal adressen in de vorige stap"
        }
    },
    "summary": {
        "header": {
            "title": "Samenvatting"
        }
    },
    "filters": {
        "buttons": {
            "showMore": "Toon meer filters",
            "showLess": "Toon minder filters"
        },
        "household": {
            "label": "Huishouden",
            "singles": "Eenpersoons",
            "families": "Families",
            "familiesWithSmallChildren": "Families met Kleine kindern ≤3 Jaar"
        },
        "buildingType": {
            "label": "Type huis",
            "appartment": "Appartement",
            "midTerraceHouse": "Tussenwoning",
            "detachedHouse": "Vrijstaand",
            "terraceHouse": "Rijtjes huis",
            "doubleHouse": "Twee onder 1 kap",
            "smallBlockFlat": "Kleine flat",
            "largeBlockFlat": "Grootte flat",
            "highRiseBuilding": "Hoogbouw",
            "cornerHouse": "hoekhuis"
        },
        "buildingUsage": {
            "label": "Gebouw gebruik",
            "unknown": "Onbekend",
            "residential": "Wonen",
            "mixedUse": "Gemengd gebruik",
            "commercial": "Commercieel gebruik"
        },
        "buyRatio": {
            "label": "Filter op eigendomsratio"
        },
        "buildYear": {
            "label": "Filter op bouwjaar"
        },
        "livingArea": {
            "label": "Filter op woonoppervlakte"
        },
        "scaleText": {
            "extremeLow": "Extreem laag",
            "veryLow": "Zeer laag",
            "low": "Laag",
            "medium": "Gemiddeld",
            "middleHigh": "Gemiddeld hoog",
            "high": "Hoog",
            "veryHigh": "Zeer hoog",
            "extremeHigh": "Extreem hoog"
        },
        "residenceLength": {
            "label": "Filter op woonduur",
            "lessThanOneYear": "Tot 1 jaar",
            "betweenOneAndTwoYears": "Tot 2 jaar",
            "betweenTwoAndThreeYears": "Tot 3 jaar",
            "betweenThreeAndFourYears": "Tot 4 jaar",
            "betweenFourAndFiveYears": "Tot 5 jaar",
            "betweenFiveAndSixYears": "Tot 6 jaar",
            "betweenSixAndEightYears": "Tot 8 jaar",
            "betweenEightAndTenYears": "Tot 10 jaar",
            "moreThanTenYears": "Meer dan 10 jaar"
        },
        "purchasingPowerClass": {
            "label": "Filter op koopkrachtklasse",
            "farBelowAverage": "Sterk ondergemiddeld",
            "belowAverage": "Ondergemiddeld",
            "lowerAverage": "Lager dan gemiddeld",
            "average": "Gemiddeld",
            "upperAverage": "Hoger dan gemiddeld",
            "aboveAverage": "Bovengemiddeld",
            "farAboveAverage": "Sterk bovengemiddeld"
        }
    }
}